import { Routes } from '@angular/router';
import { personaMatch, typeMatch } from '@core/guards/workspace-match.guard';

/**
 * Creator workspace routes.
 *
 * Pack studio lives under marketplace (`MARKETPLACE_ROUTES`); legacy
 * `/packs*` URLs redirect there.
 */
export const CREATOR_WORKSPACE_ROUTES: Routes = [
  // ── Home ───────────────────────────────────────────────────────────────────
  {
    path: '',
    pathMatch: 'full',
    canMatch: [personaMatch('creator')],
    data: { ownerScope: 'workspace' },
    loadComponent: () =>
      import(
        '../../pages/assessments/marketplace/studio/assessment-marketplace-studio.page'
      ).then((m) => m.AssessmentMarketplaceStudioPage),
  },

  // ── Studio ─────────────────────────────────────────────────────────────────
  {
    path: 'publish',
    canMatch: [typeMatch('creator')],
    data: { ownerScope: 'workspace' },
    loadComponent: () =>
      import(
        '../../pages/assessments/marketplace/studio/assessment-marketplace-studio.page'
      ).then((m) => m.AssessmentMarketplaceStudioPage),
  },
  {
    path: 'analytics',
    canMatch: [typeMatch('creator')],
    data: { ownerScope: 'workspace' },
    loadComponent: () =>
      import(
        '../../pages/assessments/marketplace/studio/assessment-marketplace-studio.page'
      ).then((m) => m.AssessmentMarketplaceStudioPage),
  },

  // Legacy creator pack URLs → marketplace-scoped paths.
  { path: 'packs', pathMatch: 'full', redirectTo: 'marketplace/packs' },
  { path: 'packs/versions', redirectTo: 'marketplace/packs/versions' },
  { path: 'packs/editor', redirectTo: 'marketplace/packs/editor' },
];
